import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

import {VendSizeDropdownComponent} from '../../components/DomainData/VendSizeDropdown.component';
import {FlavorDropdownComponent} from '../../components/DomainData/FlavorDropdown.component';
import {CardReaderDropdownComponent} from '../../components/DomainData/CardReaderDropdown.component';
import {SecurityLevelDropdownComponent} from '../../components/DomainData/SecurityLevelDropdown.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-vendorlineitem-edit',
  templateUrl: './VendorLineItemEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => VendorLineItemEditComponent)}]
})
export class VendorLineItemEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    vendorLineItemForm: FormGroup;

    vendSizeFlavorXrefs: ent.VendSizeFlavorXref[] = [];

    @Input() public requireVendSize: boolean;
    @Input() public requireFlavor: boolean;
    @Input() public requireCardReader: boolean;
    @Input() public requireSecurityLevel: boolean;
    @Input() public requireVendPrice: boolean;
    
    
    @Input() public lineItem: ent.VendorLineItem;

    @ViewChild(VendSizeDropdownComponent) public vendSizeDropdown: VendSizeDropdownComponent;
    @ViewChild(FlavorDropdownComponent) public flavorDropdown: FlavorDropdownComponent;
    @ViewChild(CardReaderDropdownComponent) public cardReaderDropdown: CardReaderDropdownComponent;
    @ViewChild(SecurityLevelDropdownComponent) public securityLevelDropdown: SecurityLevelDropdownComponent;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder, private domainDataService: serv.DomainDataService) 
    { 
        super();
        let group = {
          'vendSize' : '',
          'flavor' : '',
        //   'cardReader' : '',
        //   'securityLevel' : '',
          'vendPrice' : '',
          'setOnSite' : '',
          'casters' : '',
          'materialNumber' : {value:'', disabled: "true"},
          'materialDescription' : {value:'', disabled: "true"}
        };
        
        this.vendorLineItemForm = fb.group(group);
        

    }


    ngOnInit(): void {
        var results = this.domainDataService.getVendSizeFlavorXrefsFromCache();
        results.forEach(y=>this.vendSizeFlavorXrefs.push(y));
        
        if(this.requireVendSize) {
            this.vendorLineItemForm.controls['vendSize'].setValidators(Validators.required);
        }

        if(this.requireFlavor) {
            this.vendorLineItemForm.controls['flavor'].setValidators(Validators.required);
        }

        // if(this.requireCardReader) {
        //     this.vendorLineItemForm.controls['cardReader'].setValidators(Validators.required);
        // }

        // if(this.requireSecurityLevel) {
        //     this.vendorLineItemForm.controls['securityLevel'].setValidators(Validators.required);
        // }

        if(this.requireVendPrice) {
            this.vendorLineItemForm.controls['vendPrice'].setValidators(Validators.required);
        }

        
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.lineItem.VendSizeID = this.vendSizeDropdown.selectedID;
        this.lineItem.FlavorID = this.flavorDropdown.selectedID;
        // this.lineItem.CardReaderID = this.cardReaderDropdown.selectedID;
        // this.lineItem.SecurityLevelID = this.securityLevelDropdown.selectedID;
       
        this.onOK.emit();
        
        this.displayDialog = false;

    }

    vendSizeChange(event: any){
        this.lineItem.VendSizeID = event;
        this.setMaterialNumberAndDescription();
    }


    flavorChange(event: any){
        this.lineItem.FlavorID = event;
        this.setMaterialNumberAndDescription();
    }

    cardReaderChange(event: any){
        this.lineItem.CardReaderID = event;
    }

    securityLevelChange(event: any){
        this.lineItem.SecurityLevelID = event;
    }

    setMaterialNumberAndDescription(){
        this.lineItem.MaterialNumber = "";
        this.lineItem.MaterialDescription = "";
        var matchingRecords = this.vendSizeFlavorXrefs.filter(x=>x.FlavorID == this.lineItem.FlavorID && x.VendSizeID == this.lineItem.VendSizeID);
        if (matchingRecords && matchingRecords.length > 0){
            this.lineItem.MaterialNumber = matchingRecords[0].MaterialNumber;
            this.lineItem.MaterialDescription = matchingRecords[0].MaterialDescription;
        }
    }


}